import { useEffect, useState } from 'react';
import { User } from 'services/auth/auth.types';
import { useGetUserProfileMutation } from 'services/user/user.endpoint';
import moment from 'moment';
import { useGetUserProjectRequestsFromUserMutation } from 'services/person/request/request.endpoint';
import { UserProjectRequest } from 'services/person/request/request.types';
import { Project } from 'services/person/person.types';

export default function useRequestsVM() {
    const [me, setMe] = useState<User>({} as User);
    const [requests, setRequests] = useState<Array<UserProjectRequest>>([]);
    const [project, setProject] = useState<Project>({} as Project);
    const [isComponentLoading, setIsComponentLoading] = useState<boolean>(true);

    console.log('requests', requests);

    function formatDate(date: string) {
        return moment(date).format('D MMMM YYYY');
    }

    const [getMe, { isLoading: isMeLoading, isError: isMeError, isSuccess: isMeSuccess, error: meError, data: meResponse }] =
        useGetUserProfileMutation();

    const [
        getUserProjectRequestsFromUser,
        {
            isLoading: isUserProjectRequestsLoading,
            isError: isUserProjectRequestsError,
            isSuccess: isUserProjectRequestsSuccess,
            error: UserProjectRequestsError,
            data: UserProjectRequestsResponse
        }
    ] = useGetUserProjectRequestsFromUserMutation();

    useEffect(() => {
        getMe(undefined);
    }, []);

    useEffect(() => {
        if (isMeLoading) return;
        if (isMeError && meError) {
            return;
        }
        if (isMeSuccess && meResponse) {
            setMe(meResponse.data);
        }
    }, [isMeLoading, isMeError, isMeSuccess, meError, meResponse]);

    useEffect(() => {
        if (me?.projects?.[0]?.id) {
            setProject(me.projects[0]);
            getUserProjectRequestsFromUser({
                id: me.projects[0].id
            });
        }
    }, [me, getUserProjectRequestsFromUser]);

    useEffect(() => {
        if (isUserProjectRequestsLoading) return;
        if (isUserProjectRequestsError && UserProjectRequestsError) {
            return;
        }
        if (isUserProjectRequestsSuccess && UserProjectRequestsResponse) {
            setIsComponentLoading(false);
            setRequests(UserProjectRequestsResponse.data);
        }
    }, [
        isUserProjectRequestsLoading,
        isUserProjectRequestsError,
        isUserProjectRequestsSuccess,
        UserProjectRequestsError,
        UserProjectRequestsResponse
    ]);

    return {
        requests,
        me,
        formatDate,
        project,
        isApiRequestLoading: isUserProjectRequestsLoading,
        isComponentLoading
    };
}
